import gql from 'graphql-tag';

export const deleteAdFileMutation = gql`
  mutation deleteAdFile($id: Float!) {
    deleteAdFile(id: $id)
  }
`;
